class MFRHeroFloatingIngredients {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      ingredient: ".accent-graphic",
    };

    this.init();
  }

  init() {
    this.$ingredient = this.$element.find(this.selectors.ingredient);

    this.initIngredients();
    this.setDimensions();
  }

  setDimensions() {
    const sectionContent = this.$element
      .closest("section")
      .find(".section-content");
    const resizeObserver = new ResizeObserver(() => {
      this.$element.height(sectionContent.innerHeight());
    });
    this.$element.height(sectionContent.innerHeight());
    resizeObserver.observe(sectionContent.get(0));
  }

  initIngredients() {
    this.initScrollingAnimation();
  }

  initScrollingAnimation() {
    const tl = gsap.timeline({
      reverse: true,
      scrollTrigger: {
        trigger: this.$element,
        start: `top ${$("header.header").height()}`,
        end: `bottom ${$("header.header").height()}`,
        scrub: true,
      },
    });
    this.$ingredient.each((i, e) => {
      const randomValue =
        $(window).width() <= 1023
          ? this.getRandomValue(25, 50)
          : this.getRandomValue(35, 50);
      const bottomValue = $(window).width() <= 1023 ? "30px" : "50px";
      const isLeft = this.getElementPosition( $( e ) ) == "left";

      if (isLeft) {
        tl.to(
          $(e),
          {
            right: "unset",
            left: `${randomValue}%`,
          },
          "<"
        );
      } else {
        tl.to(
          $(e),
          {
            left: "unset",
            right: `${randomValue}%`,
          },
          "<"
        );
      }
      tl.to(
        $(e),
        {
          top: "unset",
          bottom: bottomValue,
        },
        "<"
      );
    });
    tl.to(
      this.$ingredient,
      {
        // right: "unset",
        // left: "50%",
        // top: "unset",
        bottom: "0px",
        // scale: 0.5,
        // opacity: 0,
      },
      ">"
    );
  }

  getRandomValue(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  getElementPosition(element) {
    var viewportWidth = $(window).width();
    var elementOffset = element.offset().left;
    var elementWidth = element.outerWidth();
    var elementMidpoint = elementOffset + elementWidth / 2;

    return elementMidpoint < viewportWidth / 2 ? "left" : "right";
  }
}